import { useMediaQuery, useTheme } from '@mui/material';

export type DisbursmentsVariant = 'card' | 'table';

// card: below lg (phones, tablets, md with the order Sidemenu open) — stacked cards, Balancing panel hidden.
// table: lg+ — the dense table beside the Balancing panel.
export const useDisbursmentsVariant = (): DisbursmentsVariant => {
  const theme = useTheme();
  const isCompact = useMediaQuery(theme.breakpoints.down('lg'), { noSsr: true });

  return isCompact ? 'card' : 'table';
};
